export type DonutSegment = { label: string; value: number; color: string; display?: string };

/** Pure-SVG donut (no chart lib), matching the 5 Axis product dashboard. */
export const Donut = ({ segments }: { segments: DonutSegment[] }) => {
  const R = 80;
  const r = 50;
  const cx = 120;
  const cy = 110;
  const total = segments.reduce((a, s) => a + s.value, 0) || 1;
  let angle = -Math.PI / 2;

  const arcs = segments.map((s) => {
    const a0 = angle;
    const a1 = angle + (s.value / total) * Math.PI * 2;
    angle = a1;
    const x0 = cx + R * Math.cos(a0);
    const y0 = cy + R * Math.sin(a0);
    const x1 = cx + R * Math.cos(a1);
    const y1 = cy + R * Math.sin(a1);
    const xi0 = cx + r * Math.cos(a1);
    const yi0 = cy + r * Math.sin(a1);
    const xi1 = cx + r * Math.cos(a0);
    const yi1 = cy + r * Math.sin(a0);
    const large = a1 - a0 > Math.PI ? 1 : 0;
    const d = `M ${x0} ${y0} A ${R} ${R} 0 ${large} 1 ${x1} ${y1} L ${xi0} ${yi0} A ${r} ${r} 0 ${large} 0 ${xi1} ${yi1} Z`;
    return { d, ...s };
  });

  return (
    <div style={{ display: 'flex', gap: 20, alignItems: 'center', flexWrap: 'wrap' }}>
      <svg width="240" height="220" viewBox="0 0 240 220">
        {arcs.map((a, i) => (
          <path key={i} d={a.d} fill={a.color} />
        ))}
      </svg>
      <div style={{ fontSize: 12, display: 'flex', flexDirection: 'column', gap: 8, flex: 1, minWidth: 160 }}>
        {arcs.map((a, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ width: 10, height: 10, background: a.color, borderRadius: 2, flexShrink: 0 }} />
            <span style={{ color: 'var(--p-foreground)' }}>{a.label}</span>
            <span className="tabular" style={{ color: 'var(--p-muted-fg)', marginLeft: 'auto' }}>
              {a.display ?? a.value.toLocaleString()}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
